var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

let leaflet = require("leaflet");
let Wherewolf = require("wherewolf");
let $ = require("./lib/qsa");
let colors = require("./lib/helpers/colors");
let mapContainer = $.one(".map-container");
let hasClicked = false;
let { geocodeMemphis } = require("./geocoder.js");

// set up map
var map = new leaflet.Map(mapContainer, {
  zoomSnap: 0.1,
  zoomControl: false,
  scrollWheelZoom: false,
  doubleClickZoom: false
});

leaflet
  .tileLayer("https://projects.chalkbeat.org/2024/interactive-map-chicago-school-board-districts/assets/synced/tiles/carto_light_nolabels/{z}/{x}/{y}.png")
  .addTo(map);

mapContainer.focus = () =>
  HTMLElement.prototype.focus.call(mapContainer, { preventScroll: true });

let response = await fetch("./districts-20.geojson");
let data = await response.json();
let geojson = new leaflet.GeoJSON(data, {
  style(feature) {
    let data = window.DISTRICTS[feature.properties.sub];
    return {
      color: data.term == 4 ? colors.teal2 : colors.peach2,
      weight: 2,
      fillOpacity: .3
    };
  },
  onEachFeature(feature, layer) {
    // console.log(feature.properties);
    layer.bindPopup(
      window.LABELS.tooltip.replace("%DIST%", feature.properties.sub.toUpperCase())
    );
    layer.on("click", function () {
      if (hasClicked) {
        layer.closePopup();
        map.fitBounds(geojson.getBounds());
        hasClicked = false;
      } else {
        hasClicked = true;
      }
    });
  }
});

geojson.addTo(map);
map.fitBounds(geojson.getBounds());
let wolf = Wherewolf();
wolf.add("chicago", data.features);

map.on("click", function () {
  if (geojson.getBounds()) {
    map.fitBounds(geojson.getBounds());
  }
});

// geolocate button
var here = new leaflet.Marker([0, 0], {
  icon: new leaflet.DivIcon({
    size: [16, 16],
    className: "you-are-here"
  })
});

here.addTo(map);

var fakePosition = [-89.85580444335939, 35.23552454196963].reverse();
let errorDiv = $.one(".row.error");

function youAreHere(lat, lng) {
  var latlng = new leaflet.LatLng(lat, lng);
  // latlng = new leaflet.LatLng(...fakePosition);
  here.setLatLng(latlng);
  let results = wolf.find(latlng);
  let district = results?.chicago?.sub;
  errorDiv.innerHTML = district ? "" : window.LABELS.matchError;
  geojson.eachLayer((layer) => {
    let { sub } = layer.feature.properties;
    let isDistrict = district == sub;
    let { term } = window.DISTRICTS[sub];
    layer.setStyle({
      fillOpacity: isDistrict ? 1 : .3,
      color: term == 2 ? colors.peach2 : colors.teal2
    });
    if (isDistrict) {
      layer.openPopup();
    }
  });
}

$.one(".geolocate").addEventListener("click", function () {
  navigator.geolocation.getCurrentPosition((e) => {
    youAreHere(e.coords.latitude, e.coords.longitude);
  }, (err) => console.log(err));
});

// schools dropdown
var idLookup = {};

for (var row of window.DATA) {
  idLookup[row.school_id] = row;
}

let schoolSelect = $.one(".school-select")
schoolSelect.addEventListener("input", function(e) {
  let school = idLookup[schoolSelect.value];
  youAreHere(school.lat, school.lng);
});

$.one("button.geocode").addEventListener("click", async function() {
  let address = $.one("input.geocode").value.trim();
  errorDiv.innerHTML = address ? "" : window.LABELS.invalidAddress;
  if (!address) return;
  let match = await geocodeMemphis(address);
  if (!match) {
    return errorDiv.innerHTML = window.LABELS.coordError.replace("%ADDR%", address);
  }
  youAreHere(match.coordinates.y, match.coordinates.x);
});